export enum SearchLocationTypeEnum{
  FROM_MAP= 'FROM_MAP',
  CONFIRM_ADDRESS='CONFIRM_ADDRESS'
}
